import { AppBar, Box, Button, Drawer, Toolbar, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import WestIcon from '@mui/icons-material/West';
import profileimg from '../../Assets/img/Login/User-60.png';
import ProfileData from './ProfileData.jsx/ProfileData';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { CreateAccountGet } from '../../Store/auth/createAccount';
import Loading from '../../Components/Loader/Loading';


const ProfilePage = ({ children }) => {

  const navigate = useNavigate(); // Initialize navigate hook

  const handleBackClick = () => {
    navigate(-1); // Navigate to the previous page
  };

  const email = localStorage.getItem('email')
  
    const { isLoading: fieldLoading, data: questions } = useQuery({
        queryKey: 'createAccount',
        queryFn: () => CreateAccountGet(email ? email : ''),
        cacheTime: 1000 * 60 * 5,
        staleTime: 0,
    });

  useEffect(() => {

    const email = localStorage.getItem('email')
    if (!email) {
        navigate('/', {replace:true}); 
    }
  }, [email]);

  const handleLogout = () => {
    localStorage.removeItem('email');

    navigate('/' , {replace:true});
  };

  // Render loading state or content
  if (fieldLoading) {
      return <Loading/>;
  }
  
  return (
    <div className='flex text-black'>
      {/* Top Bar */}
      <AppBar position="fixed" sx={{ zIndex: 1400, backgroundColor: '#fff', boxShadow: 'none', borderBottom: '1px solid #e0e0e0' }}>
        <Toolbar>
          <Button disableRipple onClick={handleBackClick} variant="text" sx={{ color: '#004878', textTransform: 'inherit', fontSize: '14px', '&:hover': { backgroundColor: 'transparent' } }}>
            <WestIcon />&nbsp; Profile
          </Button>
        </Toolbar>
      </AppBar>

      {/* Left Drawer */}
      <Drawer
        className="z-[12]"
        variant="permanent"
        open={true}
        sx={{
          width: '300px',
          flexShrink: 0,
          height: '100vh',
          '& .MuiDrawer-paper': {
            width: '400px',
            boxSizing: 'border-box',
            borderRight: 'none',
            padding: '30px',
          },
        }}
      >
        <Box sx={{ padding: 2, display: 'flex', alignItems: 'end', justifyContent: 'start', height: '100%' , flexDirection:'column'}}>
          <Box sx={{ marginTop: 5, border: '1px solid black', padding: '10px', borderRadius: '8px', display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'center', width: '150px' }}>
            <img src={profileimg} alt="Profile" width="100px" />
            <Typography variant='h6' sx={{ fontSize: '14px', fontWeight: 600 }}>Name</Typography>
          </Box>
          <div className='w-[110px] pt-2'>
            <Link to="/editAccount">
              <Button
                  variant='contained'
                  sx={{
                    backgroundColor: '#004878',
                    color: 'white',
                    borderRadius: '20px',
                    fontWeight: 600,
                    textTransform: 'inherit',
                    letterSpacing: '-.5px',
                    fontSize: '13px',
                    '&:hover': { backgroundColor: '#004878' },
                  }}
                >
                  Edit
                </Button>
            </Link>
          </div>
        </Box>
      </Drawer>

      {/* Content Area */}
      <Box sx={{ padding: 2, marginTop: '60px', flexGrow: 1 }}>
        <ProfileData/>
      </Box>

      {/* Right Drawer */}
      <Drawer
        anchor="right"
        className="z-[12]"
        variant="permanent"
        open={true}
        sx={{
          width: '200px',
          flexShrink: 0,
          height: '100vh',
          '& .MuiDrawer-paper': {
            width: '400px',
            boxSizing: 'border-box',
            borderLeft: 'none',
            padding: '30px',
          },
        }}
      >
        <Box sx={{ padding: 2, display: 'flex', alignItems: 'start', justifyContent: 'start', height: '100%' }}>
          <Box sx={{ marginTop: 5, display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'center', width: '150px' }}>
            <Button
              type='submit'
              variant='contained'
              onClick={handleLogout}
              sx={{
                backgroundColor: '#ED1C24',
                color: 'white',
                borderRadius: '20px',
                fontWeight: 600,
                textTransform: 'inherit',
                letterSpacing: '-.5px',
                fontSize: '13px',
                '&:hover': { backgroundColor: '#ED1C24' },
              }}
            >
              Log Out
            </Button>
          </Box>
        </Box>
      </Drawer>
    </div>
  );
};

export default ProfilePage;
